<div
    class="date"
    [class.fixed-right]="viewModel.lockPlanning"
    [class.fixed]="day.fixed"
    [class.print]="print"
    [class.nonfocussedweek]="isNonFocussedWeek"
    (click)="setFixed.emit(day)"
    (mouseenter)="mouseEnter(day)"
    (mouseleave)="mouseLeave(day)">
    {{ day.date | date: 'EEEE' }}
    <span class="datenumber">
        {{ day.date | date: 'd MMM' }}
    </span>
</div>
@for (entity of day.entities; track entity.entity.id; let i = $index) {
    <app-entity
        [class.no-plannings]="!entityIdPlanningCount.get(entity.entity.id)"
        [class.big]="entity.entity.entitytypes[0]?.is_team"
        [class.multiple]="!entity.entity.use_once || entity.entity.entitytypes[0]?.force_wide"
        [class.no-tons]="
            entity.entity.entitytypes[0]?.key === 'rentalEquipment' || entity.entity.entitytypes[0]?.key === 'wipeTruck'
        "
        [style.--h.px]="entityHeights.get(entity.entity.id)"
        [style.--cols]="columns(entity)"
        [class.force-wide]="entity.entity.entitytypes[0]?.force_wide"
        [class.use-once]="entity.entity.use_once"
        [class.curpoint]="!day.fixed"
        [class.divider]="entity.entity.entitytypes[0]?.key !== day.entities[i + 1]?.entity.entitytypes[0]?.key"
        [date]="day.date"
        [isFixed]="day.fixed"
        [item]="entity"
        [viewModel]="viewModel"
        (openPlanning)="open($event)"></app-entity>
}
<div class="bottom">
    <app-trucks
        [print]="print"
        [date]="day.date"
        [fromDate]="fromDate"
        [matTooltip]="'trucks' | tt"
        [toDate]="toDate"></app-trucks>
    <div class="tons">
        <app-tons
            [print]="print"
            [date]="day.date"
            [fromDate]="fromDate"
            [matTooltip]="'tons' | tt"
            [toDate]="toDate"></app-tons>
    </div>
</div>
